import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { WorkflowDefinition } from '../../../../../../../../api/clients/workflows/DTOs'
import TagsClient from '../../../../../../../../api/clients/workflows/TagsClient'
import { FullscreenSpinner } from '../../../../../../../../components/feedback/circular'
import AdministrationPageContainer from '../../../../../AdministrationPageContainer'
import { WorkflowsDashboardTable } from '../../../../../Workflows/WorkflowsDashboardPage'
import { FormPackageAdministrationPageProps } from '../../FormPackagePage'

type WorkflowsSectionProps = {
	packageId: number
} & FormPackageAdministrationPageProps

export const WorkflowsSection = ({
	packageId,
	...props
}: WorkflowsSectionProps) => {
	const [workflows, setWorkflows] = useState<WorkflowDefinition[]>()

	useEffect(() => {
		const executeRequest = async () => {
			const client = new TagsClient()

			const response = await client.queryWorkflows([
				{
					class: 'Core.Database.Models.Forms.FormPackage.Id',
					value: packageId.toString(),
				},
			])

			setWorkflows(response.data)
		}

		executeRequest()
	}, [packageId])

	const history = useHistory()

	const handleViewWorkflowClicked = (workflowId: number) => {
		history.push(`/_administration/_workflows/${workflowId}`)
	}

	if (workflows === undefined) return <FullscreenSpinner />

	return (
		<AdministrationPageContainer
			title="Form Package Workflows"
			tabs={props.tabLabels}
			currentTab={6}
			onTabChanged={props.onTabChanged}
			hideAttachmentsTab={props.hideAttachmentsTab}
		>
			<WorkflowsDashboardTable
				workflowDefinitions={workflows}
				onViewWorkflowClicked={handleViewWorkflowClicked}
			/>
		</AdministrationPageContainer>
	)
}
